import { useSearchParams } from "react-router-dom";

import { CatalogLocalStorage } from "@pages/Catalog";
import { CatalogTab } from "@pages/Catalog/components/utils";

import { useIsDesktop } from "@hooks/layout";

import { ArrayParam, BooleanParam, NumberParam, StringParam, useQueryParams, withDefault } from "use-query-params";

import { TFilters } from "./types";
import { customRangeQueryParam, FiltersType } from "./utils";

export const useFilters = () => {
  const isDesktop = useIsDesktop();
  const [searchParams] = useSearchParams();

  const paramsLength = [...searchParams.values()].length;

  const arrayParam = withDefault(ArrayParam, []);

  const [query, setQuery] = useQueryParams({
    [FiltersType.COMPOSER]: arrayParam,
    [FiltersType.TAGS]: arrayParam,
    [FiltersType.LENGTH]: customRangeQueryParam,
    [FiltersType.BPM]: customRangeQueryParam,
    [FiltersType.IS_ALBUMS_TAB]: withDefault(
      StringParam,
      localStorage.getItem(CatalogLocalStorage.CATALOG_TAB) || CatalogTab.TRACK,
    ),
    [FiltersType.SORT]: StringParam,

    [FiltersType.QUICK_FILTERS_CATEGORY]: withDefault(StringParam, undefined),
    [FiltersType.PAGE_NUMBER]: withDefault(NumberParam, 1),
    [FiltersType.IS_FILTERS_OPEN]: withDefault(
      BooleanParam,
      JSON.parse(localStorage.getItem(CatalogLocalStorage.FILTERS_SECTION)) === null
        ? isDesktop
        : Boolean(JSON.parse(localStorage.getItem(CatalogLocalStorage.FILTERS_SECTION))),
    ),
  });

  const handleSetQuery = (newQuery: Partial<TFilters> | null) => {
    if (!newQuery) {
      return setQuery(
        {
          isAlbumsTab: query.isAlbumsTab,
          isFiltersOpen: query.isFiltersOpen,
          pageNumber: query.pageNumber,
        },
        "push",
      );
    }
    setQuery(
      (prevState) => ({
        ...prevState,
        ...newQuery,
      }),
      paramsLength ? "pushIn" : "replace",
    );
  };

  return { query, handleSetQuery };
};
